import { CreditCardIcon, PaypalIcon } from "../../components/AscIcons";

export const DEFAULT_PAYMENT_METHODS = [
  {
    label: "Debit or credit card",
    value: "debit-or-credit-card",
    icon: <CreditCardIcon />,
  },
  { label: "PayPal", value: "paypal", icon: <PaypalIcon /> },
] as const;
